import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
var LSStripe = {
  stripeClient: null,
  publicKey: null,
  countryCode: null,
  isPaying: false,
  $payForm: null,
  initialize: function initialize(options) {
    this.$payForm = options.$payForm;
    this.publicKey = LSUtils.isDebug() || LSUtils.isQA() ? clientData.config.merchant.sandbox.public : clientData.config.merchant.stripe.public;
    this.stripeClient = Stripe(this.publicKey, {
      betas: ['payment_intent_beta_3']
    });
    this.elements = this.stripeClient.elements();
    this.countryCode = clientData.config.merchant.countryCode;
    var style = null;
    if (options.isSmallInput) {
      style = {
        base: {
          iconColor: '#666EE8',
          lineHeight: '32px',
          fontFamily: '"Open Sans",sans-serif',
          fontSize: '12px',
          color: '#000',
          padding: '10px',
          '::placeholder': {
            color: '#C4C4C4'
          }
        }
      };
    } else {
      style = {
        base: {
          iconColor: '#666EE8',
          lineHeight: '42px',
          fontFamily: '"Open Sans",sans-serif',
          fontSize: '14px',
          color: '#000',
          padding: '21px',
          '::placeholder': {
            color: '#C4C4C4'
          }
        }
      };
    }
    this.cardNumberElement = this.elements.create('cardNumber', {
      style: style
    });
    this.cardNumberElement.mount('#card-number-element');
    this.cardExpiryElement = this.elements.create('cardExpiry', {
      style: style
    });
    this.cardExpiryElement.mount('#card-expiry-element');
    this.cardCvcElement = this.elements.create('cardCvc', {
      style: style
    });
    this.cardCvcElement.mount('#card-cvc-element');
    this.bind();
  },
  bind: function bind() {},
  // ***************************************
  // STRIPE CUSTOMER API
  // ***************************************

  createCustomer: function createCustomer(clientId) {
    var email = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return $.ajax({
      url: LSUtils.url() + '/app/services/lstransaction',
      data: {
        cmd: 'createCustomer',
        clientId: clientId,
        email: email
      }
    });
  },
  updateCard: function updateCard(token, clientId) {
    var dfd = $.Deferred();
    var self = this;
    $.ajax({
      url: LSUtils.url() + '/app/services/lstransaction?cmd=customer&clientId=' + clientData.clientId,
      type: 'POST',
      data: {
        source: token
      },
      success: function success(resp) {
        resp = JSON.parse(resp);
        dfd.resolve(resp);
      },
      error: function error() {
        dfd.reject();
      }
    });
    return dfd.promise();
  },
  // ***************************************
  // STRIPE PAYMENT API
  // ***************************************

  /*
  * USE-CASE:
  * - payment for new product with new card + 3ds
  * - retrieve a token from user cc info + payment intent to use for this transaction
  */
  tokenize: function tokenize(email, tokenOnly) {
    var cardData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var self = this;
    var dfd = $.Deferred();
    if (!tokenOnly) {
      $.ajax({
        url: LSUtils.url() + '/app/services/lstransaction',
        data: {
          cmd: 'createIntent',
          clientId: clientData.clientId,
          optionIds: LSCart.getOptionIds(),
          package: LSCart.getPackageId(),
          addonPlan: LSCart.getAddonPlanId(),
          email: email,
          pagePath: location.pathname
        },
        success: function success(result) {
          var _result;
          result = JSON.parse(result);
          if ((_result = result) !== null && _result !== void 0 && (_result = _result.data) !== null && _result !== void 0 && _result.client_secret) {
            self.paymentIntent = result.data;
            dfd.resolve(null, result.data.client_secret);
          } else dfd.resolve(result.error.message, null);
        }
      });
    } else {
      if (!cardData) cardData = {
        name: $('#name').length ? $('#name').val() : $('#card-name').val(),
        address_line1: $('#address_line_1').val(),
        address_city: $('#address_city').val(),
        address_zip: $('#address_zip').val(),
        address_country: this.countryCode
      };
      this.stripeClient.createToken(this.cardNumberElement, cardData).then(function (result) {
        if (result.token) dfd.resolve(null, result.token.id);else dfd.resolve(result.error.message, null);
      });
    }
    return dfd.promise();
  },
  /*
   * USE-CASE:
   * - show the google / apple pay if available
   */
  showPaymentRequestBtn: function showPaymentRequestBtn() {
    if (LSCart.total === 0) return;
    if (LSUtils.isIE()) return;

    // Create the payment request.
    var paymentRequest = this.stripeClient.paymentRequest({
      country: clientData.config.merchant.countryCode2,
      currency: clientData.config.merchant.currency,
      total: {
        label: 'Total',
        amount: parseInt((LSCart.total * 100).toFixed(0))
      },
      requestPayerEmail: true,
      requestPayerName: true
    });
    var elements = this.stripeClient.elements();
    var prButton = elements.create('paymentRequestButton', {
      paymentRequest: paymentRequest,
      style: {
        paymentRequestButton: {
          height: '42px'
        }
      }
    });
    var self = this;
    paymentRequest.canMakePayment().then(function (paymentRequestSupport) {
      if (paymentRequestSupport) {
        //
        if (!paymentRequestSupport.applePay && self.isChrome()) {
          var $btn = $('<a href="#" class="btn btn-default btn-gpay text-center btn-md" style="padding-top: 6px;"><img src="' + LSUtils.url() + '/checkout/assets/img/gpay.png" height="28"></a>');
          $('.payment-request-button', self.$payForm).empty().append($btn);
          $btn.click(function () {
            paymentRequest.show();
            return false;
          });
        } else {
          prButton.mount('.payment-request-button', self.$payForm);
        }
        $('#instruction').html('<br />Or,');
        // Show the payment request section.
        $('#payment-request').show();
        LSCheckout.setGlideHeight();
      }
    });
    paymentRequest.on('source', function (ev) {
      if (!ev.owner) {
        // new goog (apple?) pay structure
        ev.owner = {
          email: ev.payerEmail,
          name: ev.payerName
        };
      }
      $('.input-email', self.$payForm).val(ev.owner.email);
      $('.input-name', self.$payForm).val(ev.owner.name);
      self.tokenize(ev.owner.email).done(function (err, clientSecret) {
        self.stripeClient.confirmPaymentIntent(clientSecret, {
          source: ev.source.id
        }).then(function (confirmResult) {
          if (confirmResult.error) {
            // Report to the browser that the payment failed, prompting it to
            // re-show the payment interface, or show an error message and close
            // the payment interface.
            ev.complete('fail');
            LSUtils.alert(confirmResult.error);
          } else {
            // Report to the browser that the confirmation was successful, prompting
            // it to close the browser payment method collection interface.
            ev.complete('success');
            $('#loading').show();
            // Let Stripe.js handle the rest of the payment flow.
            self.stripeClient.handleCardPayment(clientSecret).then(function (result) {
              if (result.error) {
                // The payment failed -- ask your customer for a new payment method.
                LSUtils.alert(confirmResult.error);
              } else {
                // The payment has succeeded.
                LSCheckoutProcessor.redirectWhenPaymentKeySet();
              }
            });
          }
        });
      });
    });
  },
  /*
  * USE-CASE:
  * - payment for new product with previously saved card + 3ds
  */
  show3dsModal: function show3dsModal(client_secret) {
    var dfd = $.Deferred();
    this.stripeClient.confirmCardPayment(client_secret, {}).then(function (result) {
      dfd.resolve(result);
    });
    return dfd.promise();
  },
  /*
  * USE-CASE:
  * - payment for new product with new card + 3ds
  */
  post: function post(token, email) {
    var dfd = $.Deferred();
    var self = this;
    if (self.isPaying) return;
    self.isPaying = true;
    if (!(token === 'TEST KEY' || token === 'FREE KEY')) {
      var cardholderName = $('.input-name', this.$payForm).val();
      var address = {
        city: $('.input-address-city', this.$payForm).val(),
        country: this.countryCode,
        line1: $('.input-address-line-1', this.$payForm).val(),
        postal_code: $('.input-address-zip', this.$payForm).val()
      };
      try {
        this.stripeClient.handleCardPayment(token, this.cardNumberElement, {
          source_data: {
            owner: {
              name: cardholderName,
              email: email,
              address: address
            }
          },
          shipping: {
            name: cardholderName,
            address: address
          },
          save_payment_method: true
        }).then(function (result) {
          self.isPaying = false;
          try {
            result = JSON.parse(result);
          } catch (ex) {
            // juust in case
          }
          dfd.resolve(result);
        });
      } catch (ex) {
        dfd.reject(ex.toString());
      }
    } else {
      // still sued for special paykeys
      $.ajax({
        url: LSUtils.url() + '/app/services/lstransaction',
        data: {
          clientId: clientData.clientId,
          name: $('.input-name', this.$payForm).val(),
          email: email,
          payment_method_nonce: token,
          optionIds: LSCart.getOptionIds(),
          package: LSCart.getPackageId(),
          addonPlan: LSCart.getAddonPlanId(),
          address_line1: $('.input-address-line-1', this.$payForm).val(),
          address_city: $('.input-address-city', this.$payForm).val(),
          address_zip: $('.input-address-zip', this.$payForm).val(),
          address_country: this.countryCode
        },
        success: function success(resp) {
          self.isPaying = false;
          resp = JSON.parse(resp);
          dfd.resolve(resp);
        },
        error: function error() {
          self.isPaying = false;
          dfd.reject('<b>Payment declined</b><br /><br />');
        }
      });
    }
    return dfd.promise();
  },
  /*
  * USE-CASE:
  * - payment for new product with card already saved
  */
  charge: function charge(clientId, selectedOptionIds, packageId) {
    var dfd = $.Deferred();
    $.ajax({
      url: LSUtils.url() + '/app/services/lstransaction',
      data: {
        cmd: 'chargeMainOrder',
        clientId: clientId,
        optionIds: selectedOptionIds,
        package: packageId,
        addonPlan: LSCart.getAddonPlanId(),
        offSession: false
      },
      success: function success(resp) {
        resp = JSON.parse(resp);
        dfd.resolve(resp);
      }
    });
    return dfd.promise();
  },
  /*
  * USE-CASE:
  * - payment for add-on on-session with card already saved
  */
  processPendingOption: function processPendingOption(clientData, productJson) {
    var self = this;
    var dfd = $.Deferred();
    var optionData = clientData.orderData.options[clientData.orderData.optionIds.indexOf(productJson.option.id)];
    if (optionData && optionData.paymentKey === 'PENDING_3DS' && !optionData.url) {
      dfd.resolve(clientData);
    } else {
      $.ajax({
        url: LSUtils.url() + '/app/services/lstransaction',
        data: {
          clientId: clientData.clientId,
          cmd: 'processPendingOptionCharge',
          optionId: productJson.option.id,
          offSession: false
        },
        success: function success(response) {
          clientData = JSON.parse(response).data;
          dfd.resolve(clientData);
        }
      });
    }
    return dfd.promise();
  },
  /*
  * USE-CASE:
  * - payment for failed subscription charge
  */
  processSubscription: function processSubscription(clientData, subscriptionJson) {
    var dfd = $.Deferred();
    $.ajax({
      url: LSUtils.url() + '/app/services/lstransaction',
      data: {
        clientId: clientData.clientId,
        cmd: 'subscribe',
        subscriptionName: subscriptionJson.id,
        planId: subscriptionJson.option.planId
      },
      success: function success(response) {
        clientData = JSON.parse(response).data;
        dfd.resolve(clientData);
      }
    });
    return dfd.promise();
  },
  /*
  * USE-CASE:
  * - payment for failed subscription charge
  */
  processPendingInvoice: function processPendingInvoice(clientData, subscriptionData) {
    var _subscriptionData$cha;
    var self = this;
    var dfd = $.Deferred();
    var lastChargeData = subscriptionData === null || subscriptionData === void 0 || (_subscriptionData$cha = subscriptionData.charges) === null || _subscriptionData$cha === void 0 ? void 0 : _subscriptionData$cha.last();
    if (lastChargeData && lastChargeData.paymentKey !== 'FAILURE') {
      dfd.resolve(clientData);
    } else {
      $.ajax({
        url: LSUtils.url() + '/app/services/lstransaction',
        data: {
          clientId: clientData.clientId,
          cmd: 'processPendingInvoiceCharge',
          invoiceId: lastChargeData.invoiceId,
          offSession: false
        },
        success: function success(response) {
          clientData = JSON.parse(response).data;
          dfd.resolve(clientData);
        }
      });
    }
    return dfd.promise();
  },
  // ***************************************
  // HELPERS
  // ***************************************

  isChrome: function isChrome() {
    return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  }
};
export { LSStripe };